module.exports = __webpack_public_path__ + "static/media/product-industries.b4f50d0f.svg";